import * as React from 'react';

// Types
import { UserTypes } from '../types';

type RefetchSelfProviderProps = {
    refetch: () => void;
    children?: React.ReactNode;
};

export interface IRefetchSelfContext {
    refetch?: () => void;
}

export const RefetchSelfContext: React.Context<IRefetchSelfContext> = React.createContext({});

export const RefetchSelfProvider: React.FC<RefetchSelfProviderProps> = ({ children, refetch, ...props }) => {
    return <RefetchSelfContext.Provider value={{ refetch }}>{children}</RefetchSelfContext.Provider>;
};
